import React, { useState, useEffect } from "react";
import DataTable from "react-data-table-component";
import FilterModal from "../Filter Modal/FilterModal";

export default function DataTable_Component({
  columns,
  fetchData, // (page, month, year)
  paginationData, // { data, page, limit, totalClients }
  totalPayout,
  averagePayout,
  totalTrips,
  totalFixedTrips,
  totalPpTrips,
  totalUnitsConsumed,
  averageUnitsConsumed,
  totalChargingSessions,
  totalChargingAmount,
  averageChargingAmount,
  totalLeaseAmount,
  averageLeaseAmount,
  companyOptions = [],
  feetOptions = [],
  leasingPartnerOptions = [],
  onFiltersApplied,
}) {
  const [tableData, setTableData] = useState([]);
  const [showFilterModal, setShowFilterModal] = useState(false);

  const [search, setSearch] = useState("");
  const [month, setMonth] = useState("");
  const [year, setYear] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [companyFilter, setCompanyFilter] = useState([]);
  const [feetFilter, setFeetFilter] = useState([]);
  const [statusFilter, setStatusFilter] = useState([]);
  const [leasingPartnerFilter, setLeasingPartnerFilter] = useState([]);

  const pageSize = paginationData.limit || 10;
  const handleRowsPerPageChange = (newLimit, page) => {
    fetchData(
      1,
      month || undefined,
      year || undefined,
      search,
      newLimit,
      fromDate || undefined,
      toDate || undefined,
      companyFilter,
      feetFilter,
      statusFilter,
      leasingPartnerFilter,
    );
  };

  /* ✅ INITIAL LOAD */
  useEffect(() => {
    fetchData(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  /* 🔹 UPDATE TABLE DATA */
  useEffect(() => {
    setTableData(paginationData.data || []);
  }, [paginationData.data]);

  /* 🔹 APPLY FILTERS */
  const applyFilters = () => {
    setShowFilterModal(false);

    // Store the filters that are actually applied to the table
    onFiltersApplied?.({
      month: month || undefined,
      year: year || undefined,
      search,
      fromDate: fromDate || undefined,
      toDate: toDate || undefined,
      companies: companyFilter,
      feetValues: feetFilter,
      statuses: statusFilter,
      leasingPartners: leasingPartnerFilter,
    });

    fetchData(
      1,
      month || undefined,
      year || undefined,
      search,
      pageSize,
      fromDate || undefined,
      toDate || undefined,
      companyFilter,
      feetFilter,
      statusFilter,
      leasingPartnerFilter,
    );
  };

  /* 🔹 REMOVE FILTERS */

  const removeFilters = () => {
    setMonth("");
    setYear("");
    setSearch("");
    setFromDate("");
    setToDate("");
    setCompanyFilter([]);
    setFeetFilter([]);
    setStatusFilter([]);
    setLeasingPartnerFilter([]);
    setShowFilterModal(false);

    onFiltersApplied?.({
      month: undefined,
      year: undefined,
      search: "",
      fromDate: undefined,
      toDate: undefined,
      companies: [],
      feetValues: [],
      statuses: [],
      leasingPartners: [],
    });

    fetchData(
      1,
      undefined,
      undefined,
      "",
      pageSize,
      undefined,
      undefined,
      [],
      [],
      [],
      [],
    );
  };

  /* 🔹 PAGE CHANGE */
  const handlePageChange = (page) => {
    fetchData(
      page,
      month || undefined,
      year || undefined,
      search,
      pageSize,
      fromDate || undefined,
      toDate || undefined,
      companyFilter,
      feetFilter,
      statusFilter,
      leasingPartnerFilter,
    );
  };

  return (
    <div className="table-responsive">
      {/* 🔍 SEARCH + FILTER */}
      <div className="row justify-content-between mb-2">
        <div className="col-md-3 mb-2">
          <input
            type="text"
            className="form-control"
            placeholder="Search by Vehicle Number"
            value={search}
            onChange={(e) => {
              const value = e.target.value;
              setSearch(value);
              fetchData(
                1,
                month || undefined,
                year || undefined,
                value,
                pageSize,
                fromDate || undefined,
                toDate || undefined,
                companyFilter,
                feetFilter,
                statusFilter,
                leasingPartnerFilter,
              );
            }}
          />
        </div>

        <div className="col-md-9 mb-2">
          <button
            className="btn btn-primary me-2"
            onClick={() => setShowFilterModal(true)}
          >
            Filter
          </button>
          <button className="btn btn-success me-2">
            Revenue : {totalPayout.toLocaleString()} /-
          </button>
          <button className="btn btn-success me-2">
            Avg Revenue : ₹{Number(averagePayout).toLocaleString()}
          </button>
          <button className="btn btn-success me-2">
            Total Trips : {totalTrips.toLocaleString()} /-
          </button>
          <button className="btn btn-success me-2">
            Total Fixed Trips : {totalFixedTrips.toLocaleString()} /-
          </button>
          <button className="btn btn-success me-2">
            Total PP Trips : {totalPpTrips.toLocaleString()} /-
          </button>
        </div>
      </div>

      {/* 📊 DATA TABLE */}
      <DataTable
        columns={columns}
        data={tableData}
        pagination
        paginationServer
        paginationPerPage={pageSize}
        // paginationRowsPerPageOptions={[pageSize]}
        paginationRowsPerPageOptions={[5, 10, 15, 20]} // ✅ USER CHOICE
        paginationTotalRows={paginationData.totalClients || 0}
        onChangePage={handlePageChange}
        onChangeRowsPerPage={handleRowsPerPageChange} // ✅ IMPORTANT
        fixedHeader
        highlightOnHover
        responsive
      />

      {/* 🔘 FILTER MODAL */}
      <FilterModal
        show={showFilterModal}
        onHide={() => setShowFilterModal(false)}
        applyFilters={applyFilters}
        removeFilters={removeFilters}
        month={month}
        setMonth={setMonth}
        year={year}
        setYear={setYear}
        fromDate={fromDate}
        setFromDate={setFromDate}
        toDate={toDate}
        setToDate={setToDate}
        companyFilter={companyFilter}
        setCompanyFilter={setCompanyFilter}
        feetFilter={feetFilter}
        setFeetFilter={setFeetFilter}
        companyOptions={companyOptions}
        feetOptions={feetOptions}
        statusFilter={statusFilter}
        setStatusFilter={setStatusFilter}
        leasingPartnerFilter={leasingPartnerFilter}
        setLeasingPartnerFilter={setLeasingPartnerFilter}
        leasingPartnerOptions={leasingPartnerOptions}
      />
    </div>
  );
}
